import { MMButton } from '@components'
import cn from '@integrations/classnames'
import { useMemo, useState } from '@integrations/react'
import { tr } from 'mmfintech-commons'
import { MMCheckboxGroup } from 'mmfintech-portal-commons'
import { TransactionActionModalSurface } from '../TransactionActionModalSurface'
import styles from './CustomizeTableModal.module.scss'

function CustomizeTableModal({ columns, onClose }) {
  const [visible, setVisible] = useState<string[]>(columns.visible)

  function toggleVisible(name: string): void {
    if (visible.includes(name)) {
      setVisible((prevState) => prevState.filter((v) => v !== name))
    } else {
      setVisible((prevState) => [...prevState, name])
    }
  }

  const items = useMemo(
    () => columns.meta.map(({ name: key, label, localizationKey }) => ({ key, label, localizationKey })),
    [columns.meta]
  )

  return (
    <TransactionActionModalSurface
      variant='compact'
      className={cn('table-customize-wrapper')}
      data-test='customize-transactions-table-modal'
    >
      <div className={cn(styles['table-customize-title'], 'table-customize-title', 'title')}>
        {tr('FRONTEND.TRANSACTIONS.COLUMNS.CUSTOMIZE_TITLE', 'Customize Table')}
      </div>
      <MMCheckboxGroup
        items={items}
        position='right'
        getChecked={(name: string) => visible.includes(name)}
        setChecked={toggleVisible}
        footer={
          <MMButton
            type='button'
            caption={tr('FRONTEND.TRANSACTIONS.COLUMNS.APPLY_BUTTON', 'Apply')}
            onClick={() => {
              columns.setVisible(visible)
              onClose()
            }}
            fullWidth
          />
        }
      />
    </TransactionActionModalSurface>
  )
}

export default CustomizeTableModal
